'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noPrefill = exports.propertyDetectors = undefined;

var _appearence = require('./appearence');

var _appearence2 = _interopRequireDefault(_appearence);

var _breakPropsOld = require('./break-props-old');

var _breakPropsOld2 = _interopRequireDefault(_breakPropsOld);

var _colorAdjust = require('./color-adjust');

var _colorAdjust2 = _interopRequireDefault(_colorAdjust);

var _flex = require('./flex-2009');

var _flex2 = _interopRequireDefault(_flex);

var _flex3 = require('./flex-2012');

var _flex4 = _interopRequireDefault(_flex3);

var _inlineLogicalOld = require('./inline-logical-old');

var _inlineLogicalOld2 = _interopRequireDefault(_inlineLogicalOld);

var _mask = require('./mask');

var _mask2 = _interopRequireDefault(_mask);

var _prefixed = require('./prefixed');

var _prefixed2 = _interopRequireDefault(_prefixed);

var _scrollSnap = require('./scroll-snap');

var _scrollSnap2 = _interopRequireDefault(_scrollSnap);

var _overscrollBehavior = require('./overscroll-behavior');

var _overscrollBehavior2 = _interopRequireDefault(_overscrollBehavior);

var _transform = require('./transform');

var _transform2 = _interopRequireDefault(_transform);

var _transition = require('./transition');

var _transition2 = _interopRequireDefault(_transition);

var _unprefixed = require('./unprefixed');

var _unprefixed2 = _interopRequireDefault(_unprefixed);

var _writingMode = require('./writing-mode');

var _writingMode2 = _interopRequireDefault(_writingMode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Please, keep order plugins:
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    scrollChaining,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var plugins = [_appearence2['default'], _transform2['default'], _transition2['default'], _mask2['default'], _writingMode2['default'], _colorAdjust2['default'], _breakPropsOld2['default'], _inlineLogicalOld2['default'], _unprefixed2['default'], _prefixed2['default'], _scrollSnap2['default'], _overscrollBehavior2['default'], _flex4['default'], _flex2['default']];

var propertyDetectors = exports.propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});

var noPrefill = exports.noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray(p.noPrefill));
  return a;
}, []);


//////////////////
// WEBPACK FOOTER
// ./~/react-jss/~/css-vendor/lib/plugins/index.js
// module id = 998
// module chunks = 2